import { Component, OnInit } from '@angular/core';
import {  DatePipe } from '@angular/common';

import { ReportsService } from '../../services/reports.service';
import { Allocation } from '../../../models/allocation';

import { ReportsConstants } from '../../reports.const';

declare var $: any;

@Component({
  selector: 'app-resource-allocation',
  templateUrl: './resource-allocation.component.html'
})
export class ResourceAllocationComponent implements OnInit {

  empAllocation: Allocation = new Allocation();
  timeAllocation: Allocation = new Allocation();
  isShow: boolean = false;
  count: number = 0;
  allocationDate: string;

  year: number;
  years: Array<number> = [];
  month: number;

  empTotalNumOfProject: number = 0;
  empTotalEffectiveEmployment: number = 0;
  empTotalPercentage: number = 0;

  timeTotalNumOfProject: number = 0;
  timeTotalEffectiveEmployment: number = 0;
  timeTotalPercentage: number = 0;
  timeTotalSpent: number = 0;

  empPieChartLabels:string[] = [];
  empPieChartData:number[] = [];
  timePieChartLabels:string[] = [];
  timePieChartData:number[] = [];
  pieChartType:string = 'pie';

  empLineChartData:Array<any> = [];
  empLineChartLabels: Array<any> = [];
  timeLineChartData:Array<any> = [];
  timeLineChartLabels: Array<any> = [];
  lineChartType:string = 'line';

  reportsConstants: any = ReportsConstants;

  constructor(
    private reportsService: ReportsService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    let date = new Date();
    this.years = this.getYears(date);
    this.year = date.getFullYear();
    this.month = date.getMonth()+1;
    let allocation = this.getAllocationObject(date.getFullYear(), date.getMonth()+1);
    this.getEmployeeAllocation(allocation);
    this.getTimeAllocation(allocation);
  }

  getYears(date: Date){
    let currentYear = date.getFullYear();
    return [currentYear-1, currentYear, currentYear+1, currentYear+2];
  }

  onYearChange(){
    this.month = null;
  }

  findReport(){
    let allocation = new Allocation();
    allocation.year = this.year;
    this.month ? allocation.month = this.month : '';
    this.getEmployeeAllocation(allocation);
    this.getTimeAllocation(allocation);
  }

  /**
   * 
   * @param {number} year 
   * @param {number} month 
   * @returns {Allocation} 
   * 
   * @memberOf ReportAllocationComponent
   */
  getAllocationObject(year: number, month: number) : Allocation{
    let allocation = new Allocation();
    allocation.year = year;
    allocation.month = month;
    return allocation;
  }

  /**
   * @param {Allocation} allocation 
   * Get all report allocation data
   * 
   * @memberOf ReportAllocationComponent
   */
  getEmployeeAllocation(allocation: Allocation){
    this.reportsService.getEmployeeAllocation(allocation).subscribe(
      res => {
        this.empPieChartLabels = [];
        this.empPieChartData = [];
        this.empAllocation = res.data;
        if(this.empAllocation && this.empAllocation.grid){
          this.empTotalNumOfProject = 0;
          this.empTotalPercentage = 0;
          this.empTotalEffectiveEmployment = 0;
          this.empAllocation.grid.table.forEach(table => {
            this.empTotalNumOfProject = this.empTotalNumOfProject + (table.project_count ? table.project_count : 0);
            this.empTotalEffectiveEmployment = this.empTotalEffectiveEmployment + table.effective_employment;
            this.empTotalPercentage = this.empTotalPercentage + table.percentage;
            this.empPieChartLabels.push(table.category);
            this.empPieChartData.push(table.percentage);
          });
        }
        let data = [];
        this.empLineChartData = [];
        this.empLineChartLabels = [];
        if(this.empAllocation && this.empAllocation.list){
          ReportsConstants.months.forEach(month => {
            this.empLineChartLabels.push(month.name);
            let monthObj = this.empAllocation.list[month.name];
            monthObj.forEach(list => {
              month.id === 1 ? data.push([]) : '';
              data[monthObj.indexOf(list)].push(list.percentage);
            });
          });
          this.empPieChartLabels.forEach(l => {
            this.empLineChartData.push({data: [], label: l});
          });
          data.forEach(d => {
            this.empLineChartData[data.indexOf(d)].data = d;
          });
        }
      }
    );
  }

  getTimeAllocation(allocation: Allocation){
    this.reportsService.getTimeAllocation(allocation).subscribe(
      res => {
        this.timePieChartLabels = [];
        this.timePieChartData = [];
        this.timeAllocation = res.data;
        if(this.timeAllocation && this.timeAllocation.grid){
          this.timeTotalNumOfProject = 0;
          this.timeTotalPercentage = 0;
          this.timeTotalEffectiveEmployment = 0;
          this.timeTotalSpent = 0;
          this.timeAllocation.grid.table.forEach(table => {
            this.timeTotalNumOfProject = this.timeTotalNumOfProject + (table.project_count ? table.project_count : 0);
            this.timeTotalEffectiveEmployment = this.timeTotalEffectiveEmployment + table.effective_employment;
            this.timeTotalPercentage = this.timeTotalPercentage + table.percentage;
            this.timeTotalSpent = this.timeTotalSpent + (table.spent_hours ? table.spent_hours : 0);
            this.timePieChartLabels.push(table.category);
            this.timePieChartData.push(table.spent_hours);
          });
        }
        let data = [];
        this.timeLineChartData = [];
        this.timeLineChartLabels = [];
        if(this.timeAllocation && this.timeAllocation.list){
          ReportsConstants.months.forEach(month => {
            this.timeLineChartLabels.push(month.name);
            let monthObj = this.timeAllocation.list[month.name];
            monthObj.forEach(list => {
              month.id === 1 ? data.push([]) : '';
              data[monthObj.indexOf(list)].push(list.spent_hours);
            });
          });
          this.empPieChartLabels.forEach(l => {
            this.timeLineChartData.push({data: [], label: l});
          });
          data.forEach(d => {
            this.timeLineChartData[data.indexOf(d)].data = d;
          });
        }
      }
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/modules/reports/components/resource-allocation/resource-allocation.component.ts